module.exports = __webpack_public_path__ + "img/bg0.9d3ef7d8.png";